import { ServerRestrictionType } from './RestrictionServerModel';
import { createAudioRestriction, createCustomTimeRestriction, DefaultRestriction, RestrictionType, } from '../content/ItemType';
import { isRestrictionWithAutoProgress } from '../content/restrictionTypeguards';
export const RestrictionConverter = {
    convertServerModelWithAudio(serverModel) {
        switch (serverModel.restrictionType) {
            case ServerRestrictionType.None:
                return DefaultRestriction;
            case ServerRestrictionType.AudioDuration:
                return createAudioRestriction(serverModel.autoProgress);
            case ServerRestrictionType.CustomDuration:
                if (serverModel.duration === undefined) {
                    throw Error('Failed converting restriction, restriction is custom but has no duration.');
                }
                return createCustomTimeRestriction(serverModel.duration, serverModel.autoProgress);
        }
    },
    fromServerModel(serverModel) {
        if (!serverModel) {
            return DefaultRestriction;
        }
        return this.convertServerModelWithAudio(serverModel);
    },
    toServerModel: (businessObject) => {
        const createRestrictionServerModel = (restrictionType, duration, autoProgress) => ({
            version: 2,
            restrictionType,
            autoProgress,
            ...(duration ? { duration } : {}),
        });
        switch (businessObject.restrictionType) {
            case RestrictionType.none:
                return createRestrictionServerModel(ServerRestrictionType.None);
            case RestrictionType.customTime: {
                const autoProgress = isRestrictionWithAutoProgress(businessObject) ? businessObject.autoProgress : undefined;
                return createRestrictionServerModel(ServerRestrictionType.CustomDuration, businessObject.duration, autoProgress);
            }
            case RestrictionType.audioDuration: {
                const autoProgress = isRestrictionWithAutoProgress(businessObject) ? businessObject.autoProgress : undefined;
                return createRestrictionServerModel(ServerRestrictionType.AudioDuration, undefined, autoProgress);
            }
        }
    },
};
